import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import { TicketInsurance } from './model'

interface InsuranceParams {
  tid: string
  uid: string
  itref: string
}

interface InsuranceResponse extends Response<TicketInsurance[]> {
  insurance_contidion: string
}

export const TicketInsurancesApi = {
  getTicketInsurances(params: InsuranceParams) {
    return clientApi.get<InsuranceResponse>(`/flights/insurance`, { params })
  },
}
